import { readonly, ref, shallowRef, toValue, watchEffect } from "vue";

let errorHandler = async (resp) =>
{
	throw new Error(`Request failed with status ${resp.status}`);
};

export function onHttpError(handler)
{
	errorHandler = handler;
}

export function useHttp(onReply = (data) => data, onError = () => null)
{
	const error = shallowRef(null);
	const data = ref(null);
	const busy = ref(false);
	let _seq = 0;

	async function request(url, options)
	{
		const seq = ++_seq;

		try {
			error.value = null;
			busy.value = true;

			let resp = await fetch(url, options);

			if (!resp.ok)
				resp = await errorHandler(resp, options);

			let json;

			if (resp.status !== 204)
				json = await resp.json();

			if (seq === _seq) {
				busy.value = false;
				data.value = onReply(json, resp);
			}
		}
		catch (err) {
			if (seq === _seq) {
				busy.value = false;
				error.value = err;
				onError(err);
			}
		}
	}

	function submit(url, method, data)
	{
		request(url, {
			method,
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify(data)
		});
	}

	return {
		data,
		error,
		busy: readonly(busy),
		request,
		get: (url) => request(url),
		del: (url) => request(url, { method: "DELETE" }),
		post:  (url, data) => submit(url, "POST", data),
		patch: (url, data) => submit(url, "PATCH", data),
		put:   (url, data) => submit(url, "PUT", data)
	};
}

export function useFetch(url, onReply, onError)
{
	const http = useHttp(onReply, onError);

	function get()
	{
		http.get(toValue(url));
	}

	watchEffect(() => get());

	return {
		data: http.data,
		error: http.error,
		busy: http.busy,
		get
	};
}
